import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Selector } from "../../../components/selector/Selector";
import { PrimaryButton } from "../../../components/primary/PrimaryButton";
import { FaArrowLeft } from "react-icons/fa";
import AvatarDetails from "../../../assets/icons/AvatarDetails";
import "./index.css";
import { useNavigate, useParams } from "react-router-dom";
import {
  getLandsByUser,
  getUserByClientId,
  getUserById,
} from "../../../services/UsersService";
import { useDispatch } from "react-redux";
import {
  removeLand,
  selectClient,
} from "../../../features/userSlice/userSlice";
import { roles } from "../../../constants/roles";
import { calculateDownPayment, calculateInstallments, calculateLandTotal, formattedPrice } from "../../../utils";
import { MapDetails } from "../sale/maps/MapDetails";
import { useGetLandMap } from "../sale/maps/hooks/useGetLandMap";
import { useAuth } from "../../../hooks/useAuth";
import { getLatestStep } from "../../../services/LotLandsService";
import { getStatus } from "../UserSites";

const Items = ({ title, description, className, styleDescription }) => {
  return (
    <div className={`flex flex-col justify-start items-start ${className}`}>
      <p className="text-base" style={{ color: "#024E82" }}>
        {title}
      </p>
      <p className={"text-sm " + styleDescription}>{description}</p>
    </div>
  );
};

const UserProcess = () => {
  const { user } = useAuth();
  const authUser = user?.user;

  const navigate = useNavigate();
  const { id: clientId } = useParams();

  const [userClient, setUser] = useState(null);
  const [landId, setLandId] = useState(null);
  const [lands, setLands] = useState([]);
  const [selectedUserRole, setSelectedUserRole] = useState("");
  const [showSelectorLands, setShowSelectorLands] = useState(false);
  const [maxStep, setMaxStep] = useState(null);

  const dispatch = useDispatch();
  const { handleLendMap, lend } = useGetLandMap();
  //const lands = useMemo(() => userClient?.client?.lands || [], [userClient?.client?.lands]);

  const landsList = useMemo(
    () => lands?.map((l) => ({ value: l.id, label: l.identifying_label })),
    [lands]
  );

  const selectedLand = useMemo(() => {
    if (!landId) {
      return lands?.[0] || null;
    }

    return lands.find((l) => l.id === landId);
  }, [landId, lands]);

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const navigateToProgress = useCallback(
    (clientId) => {
      if (clientId) {
        getUserByClientId({ clientId: clientId }).then((response) => {
          const { data: theUser } = response?.data;
          dispatch(selectClient(theUser));
          navigate(`/admin/details/${userClient?.id}/${theUser?.id}`);
        });
      } else {
        getUserById({ id: userClient?.id }).then((response) => {
          const { data: theUser } = response?.data;
          const userRole = theUser?.roles?.[0]?.name?.toLowerCase();
          if (userRole === roles.CLIENT) {
            dispatch(selectClient(theUser));
            navigate(`/admin/details/${userClient?.id}/${theUser?.id}`);
          }
        });
      }
    },
    [dispatch, navigate, userClient?.id]
  );

 const adapterStep = useCallback(
    (step) => {
      const role = authUser?.roles?.[0]?.name?.toLowerCase();

      if (role !== roles.CLIENT && step === 4) {
        return 3.1;
      }

      if (role === roles.CLIENT && step === 4) {
        return step;
      }

      if (role !== roles.CLIENT && step === 6) {
        return 6;
      }

      if (role === roles.CLIENT && step === 6) {
        return 7;
      }

      if (role === roles.CLIENT && step === 7) {
        return 7.2;
      }

      if (role !== roles.CLIENT && step === 7) {
        return 8;
      }

      return step;
    },
    [authUser?.roles]
  );

  useEffect(() => {
    getUserById({ id: clientId }).then((response) => {
      const { data } = response?.data;
      setSelectedUserRole(data?.roles?.[0]?.name || "");

      setUser(data);
    });
  }, [clientId]);

  useEffect(() => {
    getLandsByUser({ user_id: clientId, role: selectedUserRole }).then(
      (response) => {
        setLands(response.data?.lands);
      }
    ).finally(() => {
      setTimeout(() => {
        setShowSelectorLands(true);

      }, 1000);
    });
  }, [clientId, selectedUserRole]);

  useEffect(() => {
    dispatch(selectClient({}));
    dispatch(removeLand());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLand) {
      handleLendMap(selectedLand);
    }
  }, [handleLendMap, selectedLand]);

  useEffect(() => {
    if (selectedLand) {
      getLatestStep({ landId: selectedLand.id }).then((res) => {
        setMaxStep(res?.data?.max_step || 0);
      });
    }
  }, [handleLendMap, selectedLand]);

  if (!userClient) {
    return null;
  }

  return (
    <div className="p-5 DashboardSeller max-w-screen-xl">
      <div className="flex flex-row justify-start items-center w-full mt-10">
      <PrimaryButton
          className="mr-5 shadow-md"
          style={{
            right: 10,
            width: 50,
            justifyItems: "center",
            borderRadius: ".2rem",
          }}
          onClick={goBack}
        >
          <FaArrowLeft size={15} />
        </PrimaryButton>
        <h3 className="title text-2xl">Usuarios</h3>
      </div>

      <div
        className="bg-white rounded-xl mt-10"
        style={{ backgroundColor: "#F1F3F4" }}
      >
        <div className="flex items-center p-10 pb-0 pl-9">
          <div className="m-4 ml-0">
            <AvatarDetails />
          </div>
          <div className="w-full flex flex-col md:flex-row justify-between items-start">
            <div>
              <h1 className="userTitle">{`${userClient?.name || ""} ${userClient?.last_name || ""}`}</h1>
            </div>
            <div className="flex flex-col items-end text-primary mr-0 md:mr-40 pr-0 md:pr-10">
              <strong className="text-primary ">{`N: ${userClient?.id || ""
                }`}</strong>
              <strong className="text-primary ">
                {user?.user?.roles?.[0]?.name?.toLowerCase() === roles.SELLER
                  ? "VENDEDOR:"
                  : "ADMINISTRADOR:"}
                {` ${userClient?.seller?.administrator_name ||
                  `${user?.user?.name} ${user?.user?.last_name || ""}`
                  }`}
              </strong>
              {/*<strong className="text-primary">{`ROLE ${userClient.id || ""}`}</strong>*/}
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-start items-center w-full p-10 pt-0 gap-5 md:gap-20">
          <div>
            <Items
              className="mt-8 mr-5"
              title="Código de país"
              description={userClient?.country_code}
            />
            <Items
              className="mt-8 mr-5"
              title="Código postal"
              description={userClient?.client?.zip_code}
            />
            <Items
              className="mt-8 mr-5"
              title="Correo electrónico"
              description={userClient?.email}
            />
          </div>
          <div>
            <Items
              className="mt-8 mr-5"
              title="Telefono"
              description={userClient?.phone}
            />
            <Items
              className="mt-8 mr-5"
              title="Dirección"
              description={userClient?.client?.full_address}
            />
            <div style={{ height: "5rem" }} />
          </div>
        </div>
      </div>

      <div className="rounded-xl" style={{ backgroundColor: "#F1F3F4" }}>
        <div className="flex flex-col md:flex-row justify-between items-center sm:items-start w-full mt-10 pl-0 md:pl-10 pt-10 pr-20 ml-0 sm:ml-10 md:ml-0">
          <div className="flex flex-col md:flex-row mb-0 sm:mb-10">
            <h3 className="title text-2xl mr-0 md:mr-10">Terrenos</h3>
            <div className="w-1/5" style={{ minWidth: "10rem" }}>
              {showSelectorLands && <Selector
                name="land"
                options={landsList}
                defaultValue={{ value: landsList?.[0]?.id, label: landsList?.[0]?.label || "Seleccionar" }}
                onChange={(e) => setLandId(e.value)}
                isNewVersion
              />}
            </div>
          </div>
          <Items
            className="mt-0"
            title="Estatus"
            description={getStatus(adapterStep(maxStep)) || ""}
            styleDescription="font-semibold"
          />
        </div>
        <div className="flex flex-col md:flex-row justify-start items-center md:items-end w-full p-10 gap-5 ">
          {/* <div
            className="bg-gray rounded-md"
            style={{
              minWidth: "15rem",
              minHeight: "15rem",
              maxWidth: "15rem",
              maxHeight: "15rem",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: "150%",
                height: "150%",
                position: "absolute",
                top: -50,
                bottom: 0,
                left: -50,
                right: 0,
              }}
            >
              {lend?.render?.(
                [selectedLand],
                selectedLand,
                Number(selectedLand?.lote || 0)
              )}
            </div>
          </div> */}
          {/* <div className="show-button">
            <PrimaryButton
              disabled={landsList.length > 0 && !selectedLand}
              onClick={() => navigateToProgress(selectedLand?.client_id)}
            >
              Progreso
            </PrimaryButton>
          </div> */}

          <table className="w-full">
            <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="w-1/2">
                  <Items
                    className="mt-0"
                    title="Nombre"
                    description={selectedLand?.identifying_label || ""}
                  />
                </td>
                <td className="w-1/2">
                  <Items
                    className="mt-0"
                    title="Medidas"
                    description={selectedLand?.surface || ""}
                  />
                </td>
              </tr>
              <tr>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Adelanto"
                    description={selectedLand?.id ? formattedPrice(calculateDownPayment(calculateLandTotal(selectedLand?.price, selectedLand?.surface))?.down_payment) : ""}
                  />
                </td>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Ubicación"
                    description={selectedLand?.location || ""}
                  />
                </td>
              </tr>
              <tr>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Descuento"
                    description={selectedLand?.id ? "%0" : ""}
                  />
                </td>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Descripción"
                    description={selectedLand?.description || ""}
                  />
                </td>
              </tr>
              <tr>
                <td className="w-1/2">
                  <Items
                    className="mt-8 mr-5"
                    title="Mensualidad"
                    description={selectedLand?.id ? formattedPrice(calculateInstallments(calculateLandTotal(selectedLand?.price, selectedLand?.surface), calculateDownPayment(calculateLandTotal(selectedLand?.price, selectedLand?.surface))?.down_payment)?.installment) + ' (120 meses)' : ""}
                  />
                </td>
                <td className="w-1/2">
                  <div className=" flex flex-col md:flex-row justify-start items-end w-full py-10 gap-5">
                    <PrimaryButton
                      disabled={landsList.length > 0 && !selectedLand}
                      onClick={() =>
                        navigateToProgress(selectedLand?.client_id)
                      }
                    >
                      Progreso
                    </PrimaryButton>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          {/*<div className="flex flex-col md:flex-row justify-start items-center w-full">
            <div>
              <Items
                title="Nombre"
                description={selectedLand?.identifying_label || ""}
              />
              <Items
                title="Adelanto"
                description={selectedLand?.advance || ""}
              />
            </div>
            <div>
              <Items title="Interés" description="" />
              <Items
                title="Medidas"
                description={selectedLand?.surface || ""}
              />
            </div>
            <div>
              <Items
                title="Ubicación"
                description={selectedLand?.location || ""}
              />
              <Items
                title="Descripción"
                description={selectedLand?.description || ""}
              />
            </div>
          </div>*/}
        </div>
        {/* <div className=" flex flex-col md:flex-row justify-start items-end w-full p-10 gap-5 progress-button">
          <PrimaryButton
            disabled={landsList.length > 0 && !selectedLand}
            onClick={() => navigateToProgress(selectedLand?.client_id)}
          >
            Progreso
          </PrimaryButton>
        </div> */}
      </div>
    </div>
  );
};

export default UserProcess;
